/**
 * The ONE place a request-scoped identifier is minted.
 *
 * `crypto.randomUUID` is available in every browser US-Shop targets and in jsdom
 * under vitest. It lives here rather than being re-derived per call site so the
 * `Idempotency-Key` a page mints for a LOGICAL OPERATION and the one `bff-client`
 * mints for a one-shot request are provably the same kind of value — see
 * `sign-operation.service.ts` for why that distinction matters.
 */
export function newRequestId(): string {
  return crypto.randomUUID();
}
